import { Component, OnInit } from "@angular/core";
import { MasterDataService } from "../../Services/MasterDataService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute, Route } from "@angular/router";
import { APIServiceConnector } from "../../Services/APIServiceConnector";
import { UUID } from 'angular2-uuid';
import { QrCodeService } from "../../Services/QrCodeService";
import { AppSettings } from "../../Library/AppSettings";
import { SessionsSignalRService } from "../../Services/SessionsSignalRService";

@Component({
    selector: "QrCode",
    templateUrl: "./QrCode.html"
})
export class QrCode implements OnInit {
    qrData: any;
    elementType: 'canvas';

    public lstProperties = [];
    public SelectedPropertyId: number;

    constructor(
        public master: MasterDataService,
        public router: Router,
        public apiService: APIServiceConnector,
        public qrCodeService: QrCodeService,
        public sessionSignalR: SessionsSignalRService
    ) {
        let appFeatures = this.master.LoggedInUserData.AppFeatures;
        this.lstProperties = (this.master.LoggedInUserData.Properties || [])
            .filter(p => appFeatures['' + p.PropertyId] && (appFeatures['' + p.PropertyId].AdvanceSecurity));

        this.SelectedPropertyId = this.master.ActivePropertyID;
    }

    ngOnInit() {
        if (!AppSettings.WebSecurity || this.master.LoggedInUserData.IsPropertyAdmin) {
            this.router.navigateByUrl('home/Calls/JobConsole');
            return;
        }
        let token = this.qrCodeService.getidentifierToken();
        if(token){
            this.router.navigateByUrl('home/Calls/JobConsole');
            return;
        }
        else{
            this.generateQR();
        }
    }

    generateQR() {
        this.qrData = JSON.stringify(this.generateQRData());
    }

    generateQRData() {
        const currentUser = this.master.LoggedInUserData;
        this.qrCodeService.IdentifierToken = this.generateUUID();
        return {
            PropertyId: this.SelectedPropertyId,
            WebSessionID: this.apiService.getSessionCookie(),
            StaffId: currentUser.StaffId,
            IdentifierToken: this.qrCodeService.IdentifierToken,
            StaffName: currentUser.FName + ' ' + currentUser.LName
        }
    }

    generateUUID(){
        let value = UUID.UUID();
        return value;
    }

    onPropertyChange() {
        this.generateQR();
    }
}
